import { render, staticRenderFns } from "./stockManagementForm.vue?vue&type=template&id=6be93e5b&scoped=true"
import script from "./stockManagementForm.vue?vue&type=script&lang=js"
export * from "./stockManagementForm.vue?vue&type=script&lang=js"
import style0 from "./stockManagementForm.vue?vue&type=style&index=0&id=6be93e5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be93e5b",
  null
  
)

export default component.exports